export type SelectionEvidence={count:number;random:true;review:true;accepted:false};
/** Literal bounded motif evidence only; surrounding JavaScript is never evaluated. */
export function questionnaireSelectionEvidence(source:string):SelectionEvidence|null {
 if(source.length>5_000_000||!source.includes('function shuffle(')||!source.includes("kind === 'review'")||!source.includes('lastCorrect'))return null;
 const start=source.indexOf('function selectQuestions(');if(start<0)return null;
 const body=source.slice(start,start+3000),matches=[...body.matchAll(/\.slice\(0,\s*([0-9]{1,3})\)/g)].map(match=>Number(match[1]));
 const counts=[...new Set(matches)];if(counts.length!==1||counts[0]<1||counts[0]>100)return null;
 return {count:counts[0],random:true,review:true,accepted:false};
}
